export const JACKPOT_DEPOSIT_ITEMS         = Symbol('JACKPOT_DEPOSIT_ITEMS')
export const JACKPOT_DEPOSIT_ITEMS_SUCCESS = Symbol('JACKPOT_DEPOSIT_ITEMS')
export const JACKPOT_DEPOSIT_ITEMS_FAILURE = Symbol('JACKPOT_DEPOSIT_ITEMS')
export const JACKPOT_END_ROUND             = Symbol('JACKPOT_END_ROUND')
export const JACKPOT_UPDATE_ROUND          = Symbol('JACKPOT_UPDATE_ROUND')
export const JACKPOT_NEW_ROUND             = Symbol('JACKPOT_NEW_ROUND')
export const JACKPOT_FINISH_ROLLING        = Symbol('JACKPOT_FINISH_ROLLING')
export const JACKPOT_START_ROLLING         = Symbol('JACKPOT_START_ROLLING')
export const JACKPOT_LOAD                  = Symbol('JACKPOT_LOAD')
export const JACKPOT_LOAD_SUCCESS          = Symbol('JACKPOT_LOAD_SUCCESS')
export const JACKPOT_LOAD_FAILURE          = Symbol('JACKPOT_LOAD_FAILURE')
export const JACKPOT_LOAD_STATS            = Symbol('JACKPOT_LOAD_STATS')
export const JACKPOT_LOAD_STATS_SUCCESS    = Symbol('JACKPOT_LOAD_STATS_SUCCESS')
export const JACKPOT_LOAD_STATS_FAILURE    = Symbol('JACKPOT_LOAD_STATS_FAILURE')
export const JACKPOT_ADMIN_LOAD_OFFERS       = Symbol('JACKPOT_ADMIN_LOAD_OFFERS')
export const JACKPOT_ADMIN_LOAD_OFFERS_SUCCESS       = Symbol('JACKPOT_ADMIN_LOAD_OFFERS_SUCCESS')
export const JACKPOT_ADMIN_LOAD_OFFERS_FAILURE       = Symbol('JACKPOT_ADMIN_LOAD_OFFERS_FAILURE')
export const JACKPOT_ADMIN_RESEND_OFFER              = Symbol('JACKPOT_ADMIN_RESEND_OFFER')
export const JACKPOT_ADMIN_RESEND_OFFER_SUCCESS      = Symbol('JACKPOT_ADMIN_RESEND_OFFER_SUCCESS')
export const JACKPOT_ADMIN_RESEND_OFFER_FAILURE      = Symbol('JACKPOT_ADMIN_RESEND_OFFER_FAILURE')
